module.exports = __webpack_public_path__ + "media/images/nereport/icon_insta-e7d4dacdeeec1ed13579844b668c5f89.svg";